import {Endpoint} from '@eryxcoop/appyx-comm';

export default class CreateLeadEndpoint extends Endpoint {
    adaptValues(lead) {
        return {
            fantasy_name: lead.fantasyName,
            phone: lead.phone,
            email: lead.email,
            origin_channel: lead.originChannel,
            how_they_knew_us: lead.howTheyKnewUs,
            referral_observation: lead.referralObservation,
            commerce_type: lead.commerceType,
            commerce_type_specification: lead.commerceTypeSpecification,
            interest_products: lead.interestProducts,
            commercial_channel: lead.commercialChannel,
            business_name: lead.businessName,
            taxpayer_identification_number: lead.taxpayerIdentificationNumber,
            franchise_brand_name: lead.franchiseBrandName,
            lead_delivery_sites: lead.leadDeliverySites.map((leadDeliverySite) => ({
                name: leadDeliverySite.name,
                address: leadDeliverySite.address,
                city: leadDeliverySite.city,
                postal_code: leadDeliverySite.postalCode,
                jurisdiction: leadDeliverySite.jurisdiction,
                latitude: leadDeliverySite.latitude,
                longitude: leadDeliverySite.longitude,
            })),
        };
    }
}
